import React, { useState, useEffect } from 'react';
import './HintModal.css';
import HeavyLink from '../../../LayerSwitcher/components/HeavyLink';
import modal_logo from '../../../../_assets/img/sema-logo.png';
import modal_logo_min from '../../../../_assets/img/modal_logo_min.png';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';

const HintModal = ({ active, callback }) => {
  const clientWidth = document.documentElement.clientWidth;
  const { t } = useTranslation();

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    if (active) handleShow();
  }, [active]);

  useEffect(() => {
    callback(show);
  }, [show]);

  return (
    <Modal
      className="HintModal"
      backdrop="static"
      keyboard={false}
      size="xl"
      show={show}
      onHide={handleClose}
    >

    {/*   <div className='ContainerLogo'>
         <img
        className="img-thumbnail"
        alt="Logo"
        title="Logo"
        src={clientWidth > 350 ? modal_logo : modal_logo_min}
      />

      </div> */}
     
      <Modal.Body>

        <div className='ContainerHint'>

           <p>{t('hint.intro')}</p>
        <p>{t('hint.modulesIntro')}</p>
        <p><span>{t('hint.module1.title')}</span> {t('hint.module1.text')}</p>
        <p><span>{t('hint.module2.title')}</span> {t('hint.module2.text')}</p>
        <p><span>{t('hint.module3.title')}</span> {t('hint.module3.text')}</p>
        <p><span>{t('hint.needHelp')}</span></p>

        <div className="row LinkMenu">
       

          <div className="row">
            <div className="col-6">
              <HeavyLink  content={t('hint.links.atlas')} href="https://www.sema.ce.gov.br/atlas-costeiro-e-marinho-do-estado-do-ceara-2023/" />
            </div>
            <div className="col-6">
              <HeavyLink  content={t('hint.links.ccma')} href="https://www.sema.ce.gov.br/89965-2/" />
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <HeavyLink  content={t('hint.links.zeec')} href="https://www.sema.ce.gov.br/gerenciamento-costeiro/zoneamento-ecologico-economico-da-zona-costeira-zeec/documentos-previos-para-consulta-publica-do-zeec/" />
            </div>
            <div className="col-6">
              <HeavyLink  content={t('hint.links.ceuc')} href="https://app.powerbi.com/view?r=eyJrIjoiMzYyMzQ2ZjYtZDQyMS00NjlmLTgyODYtNTc3ODMzMzY5ZjU2IiwidCI6ImY2MjAxZmQxLWFlMzctNGZlMS1hZDJjLTUwNTc3ZTJmYTEzNiJ9&pageName=bb99d8fd3419fdc35983" />
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <HeavyLink  content={t('hint.links.guia')} href="https://drive.google.com/file/d/1ZUfe776rLGXmxt_VL89vnFH3C-nLPj8E/view" />
            </div>
            <div className="col-6">
              <HeavyLink  content={t('hint.links.manualDados')} href="https://drive.google.com/file/d/1hozOlnfeISOOhAfAvEhaA3cgQFebXWCL/view" />
            </div>
          </div>

          <div className="row">
            <div className="col-6">
              <HeavyLink content={t('hint.links.faq')} href="/portal/faq.html" />
            </div>
            <div className="col-6">
              <HeavyLink content={t('hint.links.versao')} href="/portal/versioning.html" />
            </div>

               <div className="row">
            <div className="col-6">
              <HeavyLink  content={t('hint.links.manual')} href="/portal/manual.pdf" />
            </div>
         {/*   <div className="col-6">
              <HeavyLink  content={t('hint.links.video')} href="https://youtu.be/TP_4v8EfJZ4" />
            </div> */}
          </div>
          </div>
        </div>

        <br />

        <p>
          {t('hint.terms1')}{' '}
          <a className="TermLink" href="/portal/termos_e_condicoes_de_uso_pedea.pdf" target="_blank" rel="noreferrer">
            {t('hint.termsLink')}
          </a>{' '}
          {t('hint.and')}{' '}
          <a className="TermLink" href="/portal/aviso_privacidade_pedea.pdf" target="_blank" rel="noreferrer">
            {t('hint.privacyLink')}
          </a>.
        </p>

        </div>
       
      
      </Modal.Body>
      <Modal.Footer>
      
            <Button onClick={handleClose} severity='secondary' icon='pi pi-times' raised className='BtnCloseModalHint'>
              {t('common.close')}
            </Button>
         
      </Modal.Footer>
    </Modal>
  );
};

export default HintModal;
